import { Standard } from '@getvim/vim-connect';
import { judithFleming, minnieMouse, patriciaBell, tonyStark } from '../patients';
import { orderA, orderB, orderC, orderD, orderE, orderF, orderG } from '../orders';
import { editableOrder } from '../orders/editableOrder';

export const predefinedPayloads: Record<string, Standard.Events.OrderViewedPayload> = {
  'Tony Stark - Order A': { patient: tonyStark, order: orderA, editableOrder },
  'Patricia Bell - Order B': { patient: patriciaBell, order: orderB, editableOrder },
  'Judith Fleming - Order C': { patient: judithFleming, order: orderC, editableOrder },
  'Tony Stark - Order D': { patient: tonyStark, order: orderD, editableOrder },
  'Tony Stark - Order E': { patient: tonyStark, order: orderE, editableOrder },
  'Tony Stark - Order F': { patient: tonyStark, order: orderF, editableOrder },
  'Tony Stark - Order G': { patient: tonyStark, order: orderG, editableOrder },
  'Minnie Mouse - Order G': { patient: minnieMouse, order: orderG, editableOrder },
};
